import React, {FunctionComponent} from "react";
import clsx from "clsx";
import Icon, {IconProps} from "../icon/Icon";
import Paragraph from "../Paragraph";

export type MainContentPageHeaderItem = {
    label: string;
    tag?: React.ReactElement;
    onClick?: (e: React.MouseEvent) => void;
    parent?: MainContentPageHeaderItem;
}

type MainContentPageHeaderProps = {
    title: MainContentPageHeaderItem | string;
    icon?: IconProps | React.ReactElement;
    description?: string;
    cssClass?: string;
};

const MainContentPageHeader: FunctionComponent<MainContentPageHeaderProps> = ({title, icon, description, cssClass}) => {
    const buildIcon = () => {
        if (!icon) return <></>;
        const iconProps = icon as IconProps;

        return (
            <span className="main-content-page-header__item__icon">
                {React.isValidElement(icon) ? icon : iconProps.name && <Icon {...iconProps}/>}
            </span>
        );
    };

    const getTitleItems = (): MainContentPageHeaderItem[] => {
        if (!title) return [];
        if (typeof title === "string") {
            return [{label: title}];
        }

        const items = [title];
        let currentItem = title;
        while (currentItem.parent) {
            items.push(currentItem.parent);
            currentItem = currentItem.parent;
        }
        items.reverse();
        return items;
    };

    return (
        <div className={clsx("main-content-page-header", cssClass)}>
            <div className="main-content-page-header__items">
                {getTitleItems().map(({label, tag, onClick}, index, items) =>
                    <div className="main-content-page-header__item" key={`header-item-${index}`}>
                        {index === 0 && buildIcon()}
                        {index !== 0 && <Icon name="keyboard_arrow_right"/>}
                        {index ===  items.length - 1 ?
                            <h1>{label}</h1>:
                            <span className={clsx({"main-content-page-header__item__link": onClick})} onClick={onClick}>{label}</span>
                        }
                        {tag && <div className="main-content-page-header__item__tag">{tag}</div>}
                    </div>
                )}
            </div>
            {description &&
                <Paragraph>
                    <span dangerouslySetInnerHTML={{__html: description}}/>
                </Paragraph>
            }
        </div>
    );
};

export default MainContentPageHeader;
